import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-enterprise';
import { agTheme } from '~/components/ui/tables/ag/agTheme';

// Hardcoded example data for the format preview
const exampleData = [
  { isin: 'US0378331005', current_allocation: 15.5 },
  { isin: 'US5949181045', current_allocation: 12.3 },
  { isin: 'US67066G1040', current_allocation: 8.7 },
];

// Column definitions for the example table
const exampleColDefs: ColDef[] = [
  {
    field: 'isin',
    headerName: 'isin',
    flex: 1,
    minWidth: 100,
    cellStyle: {
      fontFamily: 'monospace',
      fontSize: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    headerClass: 'compact-header',
  },
  {
    field: 'current_allocation',
    headerName: 'current_allocation',
    flex: 1,
    minWidth: 100,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '10px',
    },
    headerClass: 'compact-header',
    valueFormatter: (params) => `${params.value}%`,
  },
];

export const ExampleTable: React.FC = () => {
  return (
    <div
      className="ag-theme-quartz"
      style={{ height: '130px', width: '100%', maxWidth: '280px' }}
    >
      <style>
        {`
          .compact-header {
            font-size: 10px !important;
          }
        `}
      </style>
      <AgGridReact
        rowData={exampleData}
        columnDefs={exampleColDefs}
        theme={agTheme}
        domLayout="normal"
        headerHeight={28}
        rowHeight={24}
        suppressRowClickSelection={true}
        suppressCellFocus={true}
        suppressMenuHide={true}
        suppressContextMenu={true}
        enableCellTextSelection={true}
        defaultColDef={{
          sortable: false,
          filter: false,
          resizable: false,
          menuTabs: [],
          suppressMenu: true,
        }}
      />
    </div>
  );
};
